import {
  LocalStorageAlerts,
  LocalStorageVars,
  RegistrationData,
  RegistrationLog,
  SessionStorageVars,
} from 'constants/global'
import { SignUpTypeEnum } from 'types/api/enums'
import { PersonPSQAnswerInput } from 'types/api/types'
import { StoredUser } from 'types/global'
class Storage {
  private static parseIfFound(storageKey: string, session?: boolean) {
    let storageAPI = session ? sessionStorage : localStorage
    let stored: string | object | null = storageAPI.getItem(storageKey)
    if (stored) {
      try {
        stored = JSON.parse(stored) as string | object
      } catch (err) {
        console.warn(err)
        stored = null
      }
    }
    return stored
  }

  private static store(key: string, item: string | object, session?: boolean) {
    let storageAPI = session ? sessionStorage : localStorage
    const stringified = typeof item !== 'string' ? JSON.stringify(item) : item
    storageAPI.setItem(key, stringified)
  }

  private static clearItem(key: string, session?: boolean) {
    let storageAPI = session ? sessionStorage : localStorage
    storageAPI.removeItem(key)
  }

  static getUser() {
    // if (process?.env?.NODE_ENV === 'development' || process?.env?.REACT_APP_MOCK === 'mocking')
    //   return { userStatus: UserStatus.ACTIVE, tennisId: '', analyticsId: '' } as StoredUser
    return this.parseIfFound(LocalStorageVars.USER) as StoredUser | null
  }

  static saveUser(user: object) {
    this.store(LocalStorageVars.USER, user)
  }

  static clearUser() {
    this.clearItem(LocalStorageVars.USER)
  }

  static getAuthToken() {
    // if (process?.env?.NODE_ENV === 'development' || process?.env?.REACT_APP_MOCK === 'mocking')
    //   return 'insert dev token here'
    return localStorage.getItem(LocalStorageVars.AUTH_TOKEN) as string | null
  }

  static saveAuthToken(token: string) {
    this.store(LocalStorageVars.AUTH_TOKEN, token)
  }

  static clearAuthToken() {
    this.clearItem(LocalStorageVars.AUTH_TOKEN)
  }

  static clearAllUserData() {
    this.clearAuthToken()
    this.clearUser()
    this.removeAlertRequest('ALERT_LOGOUT')
    this.removeAlertRequest('ALERT_LOGIN')
  }

  static setAlertRequest(type: keyof typeof LocalStorageAlerts) {
    localStorage.setItem(LocalStorageAlerts[type], `${Date.now()}`)
  }

  static removeAlertRequest(type: keyof typeof LocalStorageAlerts) {
    this.clearItem(LocalStorageAlerts[type])
  }

  static getDestinationWatchlistIds() {
    return this.parseIfFound(SessionStorageVars.DESTINATION_WATCHLISTS, true) as string[] | null
  }

  static saveDestinationWatchlistIds(watchlistIds: string[]) {
    this.store(SessionStorageVars.DESTINATION_WATCHLISTS, watchlistIds, true)
  }

  static clearDestinationWatchlistIds() {
    this.clearItem(SessionStorageVars.DESTINATION_WATCHLISTS, true)
  }

  static saveRegistrationData(regData: RegistrationData) {
    this.store(LocalStorageVars.REG_DATA, regData)
  }

  static clearRegistrationData() {
    this.clearItem(LocalStorageVars.REG_DATA)
  }

  static getRegistrationData() {
    return this.parseIfFound(LocalStorageVars.REG_DATA) as RegistrationData | null
  }

  static saveRegistrationLog(regLog: RegistrationLog) {
    this.store(LocalStorageVars.REG_LOG, regLog)
  }

  static clearRegistrationLog() {
    this.clearItem(LocalStorageVars.REG_LOG)
  }

  static getRegistrationLog() {
    return this.parseIfFound(LocalStorageVars.REG_LOG) as RegistrationLog | null
  }

  static savePublicRmg(answers: PersonPSQAnswerInput[]) {
    this.store(LocalStorageVars.PUBLIC_RMG_ANSWERS, answers)
  }

  static clearPublicRmg() {
    this.clearItem(LocalStorageVars.PUBLIC_RMG_ANSWERS)
  }

  static getPublicRmg() {
    return this.parseIfFound(LocalStorageVars.PUBLIC_RMG_ANSWERS) as PersonPSQAnswerInput[] | null
  }

  static saveRegistrationSeed(type: SignUpTypeEnum) {
    this.store(LocalStorageVars.REG_SEED, type)
  }

  static clearRegistrationSeed() {
    this.clearItem(LocalStorageVars.REG_SEED)
  }

  static getRegistrationSeed() {
    return localStorage.getItem(LocalStorageVars.REG_SEED) as SignUpTypeEnum | null
  }
}

export default Storage
